import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const disqus = defineConnector({
  identifier: "disqus",
  name: "Disqus",
  tagLine: "Comment hosting",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://disqus\\.com/api/.*",
  auth: (app) =>
    queryAuth([{ name: "api_key", value: app.secret.accessToken }]),
  steps: [
    {
      title: "Get your access token",
      items: [
        {
          kind: "markdown",
          content:
            "Go to [Disqus API Applications](https://disqus.com/api/applications/) and create or select an application to get your access token.",
        },
      ],
    },
    {
      title: "Enter your access token",
      items: [
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://disqus.com/api/3.0/users/details.json",
  },
});
